module.exports = __webpack_public_path__ + "img/communication4.b565cee7.png";